<script>
export default {
	data: () => {
		return {
			showBanner: false,
		};
	},
	mounted() {
		this.showBanner = this.$cookies.get('cookie_consent') === null;
	},
	methods: {
		acceptCookies() {
			this.$cookies.set('cookie_consent', 'accepted', '365d');
			this.$gtm.enable(true);
			this.showBanner = false;
		},
		declineCookies() {
			this.$cookies.set('cookie_consent', 'declined', '180d');
			this.showBanner = false;
		},
	},
};
</script>

<template>
	<div
		v-if="showBanner"
		class="fixed bottom-0 inset-x-0 z-50 bg-secondary-light dark:bg-secondary-dark border-t-2 border-primary-light dark:border-ternary-dark shadow-lg"
	>
		<div
			class="container mx-auto px-4 py-4 flex flex-col sm:flex-row items-center gap-3 sm:gap-6"
		>
			<p
				class="text-sm text-primary-dark dark:text-ternary-light flex-1 text-center sm:text-left"
			>
				{{ $t('cookie_banner_text') }}
				<router-link
					to="/gdpr"
					class="underline hover:text-indigo-600 dark:hover:text-indigo-300"
					>{{ $t('cookie_learn_more') }}</router-link
				>
			</p>
			<div class="flex gap-3 shrink-0">
				<button
					@click="declineCookies"
					class="px-6 py-2 text-sm rounded-lg border border-gray-400 text-primary-dark dark:text-ternary-light hover:bg-gray-100 dark:hover:bg-ternary-dark transition duration-300"
				>
					{{ $t('cookie_decline') }}
				</button>
				<button
					@click="acceptCookies"
					class="px-6 py-2 text-sm rounded-lg bg-indigo-500 hover:bg-indigo-600 text-white transition duration-300"
				>
					{{ $t('cookie_accept') }}
				</button>
			</div>
		</div>
	</div>
</template>
